import login_store from './components/login_store'
import user_store from './components/user_store';
import global_store from './components/global_store';
import sensitive_store from './components/sensitive_store';
import group_store from './components/group_store';
import message_store from './components/message_store';
import setting_store from './components/setting_store';
import robot_store from './components/robot_store';
import channel_store from './components/channel_store';

export default {
    login_store,
    user_store,
    global_store,
    sensitive_store,
    group_store,
    message_store,
    setting_store,
    robot_store,
    channel_store
}


// WEBPACK FOOTER //
// ./src/store/modules.js